// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfilePopup__container-bf28ed {
  max-height: 100%;
  flex: 1;
  --sharedmedia-column-count: 4;
}

.UserProfilePopup__scroll-container-ccb8b2 {
  position: relative;
  overflow: auto;
  height: 100%;
}

.UserProfilePopup__profile-ec4ee5 {
  margin-top: 24px;
  margin-bottom: 16px;
}

.UserProfilePopup__profile-meta-block-be55d7 {
  --meta-block-actions-background: var(--base-10);
}

.UserProfilePopup__shared-data-fa7680 {
  margin-top: 8px;
  --padding: 24px;
}

.UserProfilePopup__close-a804a0 {
  position: absolute;
  top: 20px;
  inset-inline-end: 20px;
}

.UserProfilePopup__user-info-e501e8 {
  margin-bottom: var(--indent-24px);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/UserProfilePopup/UserProfilePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,OAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,+CAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,iCAAA;AACF","sourcesContent":[".container {\n  max-height: 100%;\n  flex: 1;\n  --sharedmedia-column-count: 4;\n}\n\n.scroll-container {\n  position: relative;\n  overflow: auto;\n  height: 100%;\n}\n\n.profile {\n  margin-top: 24px;\n  margin-bottom: 16px;\n}\n\n.profile-meta-block {\n  --meta-block-actions-background: var(--base-10);\n}\n\n.shared-data {\n  margin-top: 8px;\n  --padding: 24px;\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  inset-inline-end: 20px;\n}\n\n.user-info {\n  margin-bottom: var(--indent-24px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserProfilePopup__container-bf28ed`,
	"scroll-container": `UserProfilePopup__scroll-container-ccb8b2`,
	"scrollContainer": `UserProfilePopup__scroll-container-ccb8b2`,
	"profile": `UserProfilePopup__profile-ec4ee5`,
	"profile-meta-block": `UserProfilePopup__profile-meta-block-be55d7`,
	"profileMetaBlock": `UserProfilePopup__profile-meta-block-be55d7`,
	"shared-data": `UserProfilePopup__shared-data-fa7680`,
	"sharedData": `UserProfilePopup__shared-data-fa7680`,
	"close": `UserProfilePopup__close-a804a0`,
	"user-info": `UserProfilePopup__user-info-e501e8`,
	"userInfo": `UserProfilePopup__user-info-e501e8`
};
module.exports = ___CSS_LOADER_EXPORT___;
